import { h } from '@stencil/core';

const Logo = ({ className = '', color = '#7263FA' }) => {
  return (
    <svg
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox='0 0 256 256'
      fill="none">
      <path fill={color} d="M128 185h57v57h-57v-57ZM128 14h57v57h-57V14ZM71 185h57v57H71v-57ZM71 14h57v57H71V14ZM14 71h57v57H14V71ZM185 71h57v57h-57V71ZM71 14v57H14l57-57ZM14 128h57v57H14v-57ZM185 128h57v57h-57v-57ZM14 185h57v57l-57-57ZM185 14l57 57h-57V14Z"/>
    </svg>
  );
};

export default Logo;
